export { PrivacyPage as default } from '@/components/pages/Legal/Privacy'
